<template>
  <div class="most-read">
    <SectionHeader
      v-if="staticData?.item?.title || title"
      :level="2"
      :label="staticData?.item?.title || title"
      class="most-read-title"
    />
    <ol v-if="mostReadArticles" class="most-read-items">
      <MostReadItem
        v-for="(item, index) in mostReadArticles"
        :key="`most-read-${index + 1}`"
        :item="item as never"
        :is-error-layout="isErrorLayout"
        :data-index="index + 1"
      />
    </ol>
  </div>
</template>

<script setup lang="ts">
import useMostRead from '~/composables/useMostRead';
import type { ICmsSectionMostRead } from '~~/types/_cms-types';

const mostReadArticles = await useMostRead();

interface IProps extends ICmsSectionMostRead {
  staticData?: never;
  title?: string;
  isErrorLayout?: boolean;
}

withDefaults(defineProps<IProps>(), {
  staticData: undefined,
  isErrorLayout: false,
  title: undefined,
});
</script>

<style lang="postcss" scoped>
.most-read {
  display: flex;
  flex-direction: column;
}

.most-read-title {
  color: hsl(var(--color-primary-700));

  @add-mixin heading-xl;
}

.most-read-items {
  --most-read-items-row-gap: var(--unit-8);
  --most-read-items-column-gap: var(--unit-24);
  --most-read-items-template-columns: repeat(1, 1fr);

  display: grid;
  grid-template-columns: var(--most-read-items-template-columns);
  row-gap: var(--most-read-items-row-gap);
  column-gap: var(--most-read-items-column-gap);

  @media (--md-viewport) {
    --most-read-items-template-columns: repeat(2, 1fr);
    --most-read-items-row-gap: var(--unit-16);
    --most-read-items-column-gap: var(--unit-16);
  }

  @media (--lg-viewport) {
    --most-read-items-row-gap: var(--unit-16);
    --most-read-items-column-gap: var(--unit-24);
  }
}
</style>
